// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { PatientNameResponse } from './patient-name-response';

/** See com.rev360.pms.api.controller.reporting.accounting.AgingReportResponse */
/* istanbul ignore next */
@GandalfModel
export class AgingReportResponse extends GandalfModelBase {

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	balance0To30!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	balance30To60!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	balance60To90!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	balance90To120!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	balanceOver120!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	balanceTotal!: number | null;

	@GandalfProperty({ designType: String })
	locationName!: string | null;

	@GandalfProperty({ designType: PatientNameResponse })
	patientNameResponse!: PatientNameResponse | null;

	@GandalfProperty({ designType: String })
	payerName!: string | null;

	@GandalfConstantDecorator(constants.PayerType)
	@GandalfProperty({ designType: constants.PayerType })
	payerType!: constants.PayerType | null;

}
